export enum LayoutEnum {
  tiles = 'Tiles'
}
